import {
    TOGGLE_KEYBOARD_NAVIGATION,
    SET_FOOTER_PROPS,
    RESET_FOOTER_PROPS
} from "../constants/global.constant";

// Note: selectedItems, selectionMode, lastSelectedItem moved to Zustand canvasStore

const initialState = {
    keyboardNavigationActive: true,
    footerBarProps: {} // Props to be passed to FooterBar component
};

const globalReducer = (state = initialState, action) => {
    switch (action.type) {
        case TOGGLE_KEYBOARD_NAVIGATION:
            return {
                ...state,
                keyboardNavigationActive: action.payload,
            };
        case SET_FOOTER_PROPS:
            return {
                ...state,
                footerBarProps: {
                    ...state.footerBarProps,
                    ...action.payload
                }
            };
        case RESET_FOOTER_PROPS:
            return {
                ...state,
                footerBarProps: {}
            };
        default:
            return state;
    }
};

export default globalReducer;
